<template>
    <Dropdown v-if="authInfo">
        <span class="cursor-pointer">
            <span class="dropdown-label-account">
                {{ authInfo.user.fullName }}
                {{ authInfo.user.refDepartment ? `(${authInfo.user.refDepartment.nameTh})` : "" }}
            </span>
            <span class="ml-2" v-if="authInfo.user.refImage"><Avatar size="large" :src="authInfo.user.refImage.url"></Avatar></span>
        </span>
        <template v-slot:overlay>
            <Menu>
                <MenuItem>
                    <router-link :to="{ name: 'profile' }">
                        <CIcon file="user.svg"></CIcon>
                        <span class="ml-2">{{ $t("button.profile") }}</span>
                    </router-link>
                </MenuItem>
                <!--
                <MenuItem>
                    <router-link :to="{ name: 'user-insteads' }">
                        <CIcon file="role.svg"></CIcon>
                        <span class="ml-2">{{ $t("model.userInstead.modelName") }}</span>
                    </router-link>
                </MenuItem>
                -->
                <MenuItem @click="onClickLogout">
                    <a href="javascript:void(0)">
                        <CIcon file="logout.svg"></CIcon>
                        <span class="ml-2">{{ $t("button.logout") }}</span>
                    </a>
                </MenuItem>
            </Menu>
        </template>
    </Dropdown>
</template>

<script>
import { defineComponent, computed, defineAsyncComponent } from "vue";
import { useStore } from "vuex";
import { Avatar, Dropdown, Menu } from "ant-design-vue";
import { onClickLogout } from "./app-layout.logic";

export default defineComponent({
    components: {
        Avatar,
        Dropdown,
        Menu,
        MenuItem: Menu.Item,
        CIcon: defineAsyncComponent(() => import("../../icon/CIcon")),
    },
    setup() {
        const store = useStore();
        const authInfo = computed(() => store.state.resource.auth.info);
        return { authInfo, onClickLogout };
    },
});
</script>

<style>
.dropdown-label-account {
    max-width: 250px;
    display: inline-block;
    line-height: 1.25;
    vertical-align: middle;
}
</style>
